import { createActions } from 'redux-actions';

const actions = createActions({
  SEND_VERIFICATION_CODE: (data) => data,
  SEND_VERIFICATION_CODE_FAILED: (data) => data,
  SEND_VERIFICATION_CODE_SUCCESS: () => { },
  VERIFY_CODE: (data) => data,
  VERIFY_CODE_ATTEMPT: () => { },
  VERIFY_CODE_FAILED: (data) => data,
  VERIFY_CODE_RESET: () => { },
  VERIFY_CODE_SUCCESS: (data) => data,
});

export const {
  sendVerificationCode,
  sendVerificationCodeFailed,
  sendVerificationCodeSuccess,
  verifyCode,
  verifyCodeAttempt,
  verifyCodeFailed,
  verifyCodeReset,
  verifyCodeSuccess,
} = actions;
